import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const REACT_APP_END_POINT_SUBMIT_CONTACT_US_FORM =
  process.env.REACT_APP_END_POINT_SUBMIT_CONTACT_US_FORM;

export const contact_Us_Form_Api = createAsyncThunk(
  "submit/contact/us/form",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(
        REACT_APP_END_POINT_SUBMIT_CONTACT_US_FORM,
        "PATCH",
        patchData
      );
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const contact_Us_Form_Slice = createSlice({
  name: "submitContactUsForm",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    loading: null,
  },
  reducers: {
    setDefault_Contact_Us_Form: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contact_Us_Form_Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(contact_Us_Form_Api.fulfilled, (state, action) => {
        state.response = action.payload;
        state.success = action.payload?.success;
        state.statusCode = action.payload?.code;
        state.loading = false;
      })
      .addCase(contact_Us_Form_Api.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Contact_Us_Form } = contact_Us_Form_Slice.actions;
export default contact_Us_Form_Slice.reducer;
